import { Button, Col, Row } from 'antd';
import React, { useState } from 'react'
import { AllSubPeriodComponent } from '../Components/SubPeriod/AllSubPeriodComponent';
import { EditSubPeriodComponent } from '../Components/SubPeriod/EditSubPeriodComponent';
import { AddSubPeriodComponent } from '../Components/SubPeriod/AddSubPeriodComponent';
import { addButton } from '../assets/styles/stylesMain';
// ======================================================================
export const SubPeriod = ({ setLoading, showMessage, periodId, periodTitle, periodCategoryId, onBackClick }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [version, setVersion] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [subPeriodId, setSubPeriodId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "All" ?
                    <AllSubPeriodComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        periodId={periodId}
                        periodTitle={periodTitle}
                        version={version}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onAddClick={()=>setView("Add")}
                        onEdit={(id) => { setSubPeriodId(id); setView("Edit") }}
                        onRowDeleted={() => { setVersion(version + 1); setView("All"); }}
                        onBackClick={onBackClick}
                    />: <></>
            }
            {view === "Edit" ?
                <EditSubPeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={subPeriodId}
                    periodCategoryId={periodCategoryId}
                    rowUpdated={() => { setVersion(version + 1); setView("All"); }}
                    cancelEdit={() => setView("All")}
                /> : <></>
            }
            {view === "Add" ? 
                <AddSubPeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    periodId={periodId}
                    periodCategoryId={periodCategoryId}
                    rowInserted={() => { setVersion(version + 1); setView("All"); }}
                    cancelInsert={() => setView("All")}
                /> :<></>
             }
        </>
    )
}
